import { render, staticRenderFns } from "./item.vue?vue&type=template&id=438ad5ba&scoped=true&"
import script from "./item.vue?vue&type=script&lang=js&"
export * from "./item.vue?vue&type=script&lang=js&"
import style0 from "./item.vue?vue&type=style&index=0&id=438ad5ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438ad5ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('438ad5ba')) {
      api.createRecord('438ad5ba', component.options)
    } else {
      api.reload('438ad5ba', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=438ad5ba&scoped=true&", function () {
      api.rerender('438ad5ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/Skills/item.vue"
export default component.exports